import icons from "../../ultils/icons";
import { formatMoney } from "../../helper";
import { useNavigate } from "react-router-dom";
import path from "../../ultils/path";

const StatisticalRightItem = ({ data }: any) => {
  const { FaSortDown, FaSortUp } = icons;

  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        navigate(path.REVENUE_STORE, {
          state: { storeCode: data?.storeCode },
        });
      }}
      className="cursor-pointer flex min-h-[10vh] max-sm:min-h-[11vh] justify-between rounded-xl p-[10px] gap-1 pr-2 pb-3 border-b-1 border-gray-300 mt-2 bg-white hover:bg-gray-100"
    >
      <div className="flex flex-col justify-between">
        <span className="text-base text-gray-900 font-bold sm:text-sm max-sm:text-[10px]">
          {data?.storeName}
        </span>
        {data?.storeCode && (
          <div className="border-1 min-w-[90px] max-sm:w-[60px] rounded-full border-gray-400 flex items-center sm:text-sm max-sm:text-[10px] justify-center max-sm:px-[4px] px-[6px] py-[2px] text-sm text-gray-500 font-semibold">
            {data?.storeCode}
          </div>
        )}
      </div>
      <div className="flex flex-col items-end justify-between">
        {data?.isIncrease ? (
          <div className="flex gap-3 font-semibold text-green-500 text-base items-center max-sm:text-sm">
            {formatMoney(data?.revenueMonthCurrent)}
          </div>
        ) : (
          <div className="flex gap-3 font-semibold text-green-500 text-base items-center max-sm:text-sm">
            {formatMoney(data?.revenueMonthCurrent)}
          </div>
        )}
        {data?.isIncrease ? (
          <div className="flex p-[4px] max-sm:p-[2px] rounded-full bg-green-400 gap-1 bg-opacity-20 pr-2 text-green-600 justify-center items-center text-center">
            <FaSortUp className="mt-2"></FaSortUp>
            <small className="font-semibold max-sm:text-[12px]">
              {data?.percent.toFixed(2)}%
            </small>
          </div>
        ) : (
          <div className="flex p-[4px] max-sm:p-[2px] rounded-full bg-red-400 gap-1 bg-opacity-20 pr-2 text-red-600 justify-center items-center text-center">
            <FaSortDown className="-mt-2"></FaSortDown>
            <small className="font-semibold max-sm:text-[12px]">
              {data?.percent.toFixed(2)}%
            </small>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatisticalRightItem;
